import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Leaflet's stylesheet is render-critical — it carries
// `.leaflet-container { overflow: hidden }`, without which the tiles spill out
// of the map pane and push the page sideways. It used to come from unpkg, so a
// slow or blocked CDN broke the layout; leaflet is already a dependency, so it
// ships in the bundle instead.
import 'leaflet/dist/leaflet.css';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
